// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3TEcT","select":"Header_select__10QFK","clinic":"Header_clinic__1fpH8"};